import { SubgraphType } from 'config/subgraph'
import { useSubgraphConfig } from 'hooks/useSubgraphConfig'
import { useV2ProtocolDayDatasQuery } from 'queries/v2/generated'
import { useEffect } from 'react'
import { useSetDayDataV2 } from 'state/protocolData/hooks/useSetDayDataV2'

export const useProtocolDataV2 = () => {
  const subgraphConfig = useSubgraphConfig(SubgraphType.V2)

  const { setDayData, setLoading } = useSetDayDataV2()

  const { data, isLoading: loading, error, refetch } = useV2ProtocolDayDatasQuery({ endpoint: subgraphConfig.endpoint })

  const allDatas = data?.uniswapDayDataV2S

  // Processing the received data
  useEffect(() => {
    if (!loading && data) {
      setDayData(data.uniswapDayDataV2S)
    }
    setLoading(loading)
  }, [data, loading, setDayData, setLoading])

  useEffect(() => {
    if (error) {
      console.error('Error fetching Day Data V2:', error instanceof Error ? error.message : String(error))
    }
  }, [error])

  const tvlUSD = allDatas?.length ? parseFloat(allDatas[allDatas.length - 1].totalLiquidityUSD) : null

  const totalVolumeUSD = allDatas?.reduce((total, data) => {
    return total + parseFloat(data.dailyVolumeUSD)
  }, 0)

  const formattedData = {
    tvlUSD,
    totalVolumeUSD,
  }

  return {
    isLoading: loading,
    data: formattedData,
    isError: !!error,
    refetch,
  }
}
